module.exports = __webpack_public_path__ + "img/sus_yes.cbbd7227.png";